import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';

interface BannerProps {
  dismissBanner?: () => void;
  children?: any;
  window: Window;
};

const styles = {
  banner: RX.Styles.createViewStyle({
    backgroundColor: colors.alert,
    maxWidth: 1200,
    padding: 4,
  }),
  bannerText: RX.Styles.createViewStyle({
    backgroundColor: '#D95852',
    padding: 12
  }),
  close: RX.Styles.createButtonStyle({
    paddingRight: 6,
    position: 'absolute',
    right: 0,
  }),
  mobile: RX.Styles.createViewStyle({
    // bottom: 24
  }),
  web: RX.Styles.createViewStyle({
    // bottom: 0,
    // position: 'absolute',
  }),
  x: RX.Styles.createTextStyle({
    fontSize: 20,
    fontWeight: 'bold'
  }),
};

export class Banner extends RX.Component<BannerProps, RX.Stateless> {

  constructor(props: BannerProps) {
    super(props);
  }

  public render() {
    const { window: { width, landscape, multiplier = 1 }, dismissBanner, children } = this.props;
    const web = RX.Platform.getType() !== 'web';

    return (
      <RX.View style={[
        styles.banner,
        { width, minHeight: width < 990 && RX.Platform.getType() !== 'web' && landscape ? 400 * multiplier : 0 },
        web ? styles.mobile : styles.web]}
      >
        {children}
        {dismissBanner && <RX.Button style={styles.close} onPress={dismissBanner}>
          <RX.Text style={styles.x}>X</RX.Text>
        </RX.Button>}
      </RX.View>
    );
  }
}

export default connect(mapStateToProps)(Banner);



// WEBPACK FOOTER //
// ./src/components/banner/index.tsx